module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.course) ? _c('div', {
    staticClass: "chapter-page"
  }, [_c('ChapterStats', {
    staticClass: "chapter-stat",
    style: (_vm.safeTopVar),
    attrs: {
      "words": _vm.countWords,
      "ranking": _vm.getRank,
      "grammer": _vm.countLaws,
      "sentance": _vm.countSentences,
      "page": _vm.page,
      "changePage": _vm.changePage
    }
  }), _vm._v(" "), (_vm.page == 'main') ? _c('ChapterHeader', {
    staticClass: "chapter-head",
    style: (_vm.safeTopChap),
    attrs: {
      "title": _vm.courseChapter ? _vm.courseChapter.name : _vm.$t('chapter.chapter-page.loading'),
      "prev": _vm.prevChapter,
      "next": _vm.nextChapter
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page == 'main') ? _c('ChapterCourse', {
    staticClass: "chapter-course",
    attrs: {
      "course": _vm.courseChapter ? _vm.courseChapter : null,
      "id": _vm.id ? _vm.id : null,
      "progress": _vm.userProgress,
      "nextLesson": _vm.nextLesson,
      "permission": _vm.userPermission
    }
  }) : _vm._e(), _vm._v(" "), (_vm.sortByType) ? _c('ChapterCourseByType', {
    staticClass: "chapter-course",
    attrs: {
      "course": _vm.courseChapter ? _vm.courseChapter : null
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page == 'savedwords') ? _c('SavedWords') : _vm._e(), _vm._v(" "), (_vm.page == 'settings') ? _c('Settings', {
    attrs: {
      "permission": _vm.userPermission
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page == 'videos') ? _c('Videos', {
    attrs: {
      "permission": _vm.userPermission
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page == 'dictionary') ? _c('Dictionary') : _vm._e(), _vm._v(" "), (_vm.page == 'grammar' || _vm.page == 'sentence') ? _c('Externals', {
    attrs: {
      "exType": _vm.page,
      "permission": _vm.userPermission,
      "changePage": _vm.changePage
    },
    on: {
      "hideFooter": _vm.hideFooter,
      "showFooter": _vm.showFooter
    }
  }) : _vm._e(), _vm._v(" "), (_vm.page == 'savedwords' || _vm.page == 'main') ? _c('ChapterBtn', {
    staticClass: "above-footer-fixed",
    style: (_vm.safeBottomVarBtn),
    attrs: {
      "nextLesson": _vm.nextLesson,
      "page": _vm.page,
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showfoot) ? _c('ChapterFooter', {
    staticClass: "footer-fixed",
    style: (_vm.safeBottomVar),
    attrs: {
      "changePage": _vm.changePage,
      "page": _vm.page,
      "nextLesson": _vm.nextLesson
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "iosFooter",
    style: (_vm.safeBottomVar)
  })], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-786bc62d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter/chapter-page.vue
// module id = 551
// module chunks = 0